import { render, staticRenderFns } from "./ManageLimits.vue?vue&type=template&id=0775d25c&scoped=true"
import script from "./ManageLimits.vue?vue&type=script&lang=ts"
export * from "./ManageLimits.vue?vue&type=script&lang=ts"
import style0 from "./ManageLimits.vue?vue&type=style&index=0&id=0775d25c&prod&scoped=true&lang=css"
import style1 from "./ManageLimits.vue?vue&type=style&index=1&id=0775d25c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775d25c",
  null
  
)

export default component.exports